import React from 'react';
import StyledPaper from 'views/common/components/UI/MainWidget/AutoCompleteMenu/AutoCompleteMenu.styles';

const AutoCompleteMenu = ({ children, ...restOfProps }) => (
  <StyledPaper className="customDropDown" {...restOfProps}>
    {children}
  </StyledPaper>
);
export { AutoCompleteMenu };
